<template>
  <div class="keep-alive">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <!-- 不缓存的视图 -->
    <!-- <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template> -->
    
    <router-view></router-view>
  </div>
</template>

<script>
export default {
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
}
</style>
